import { useState } from "react"
import Select from 'react-select'
import Header from "../../../../../../Components/Header/Header"
import Sidebar from "../../../../../../Components/Sidebar/Sidebar"
import DeletePopup from "../../../GardenPopup/DeletePopup"
import { WardNameDataDDL } from "../../../../../../Components/CommonDDL/WardNameDataDDL"
import { SeveragePumpingStationDataDDL } from "../../../../../../Components/CommonDDL/SeveragePumpingStationDataDDL"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../../../../Helper/Context"
import { PumpingOperationDeleteAPI, PumpingOperationExportTableDataAPI, PumpingOperationTableDataAPI } from "../../../../../../Redux/SeverageDashboardSlice/SewerageDailyWorkMasterSlice/PumpingOperationSlice"
import moment from 'moment'
import ViewURL from "../../../../../../Components/ViewURL/ViewURL"
import { Loading } from "../../../../../../Helper/Loading"
import { Pegination } from "../../../../../../Components/Pegination/Pegination"
import { useSearchParams } from "react-router-dom"
import { PreventivePumpingOperationExport } from "./PreventivePumpingOperationExport"
import { TableNote } from "../../../../../../Components/Note/Note"
import { toastErrorr } from "../../../../../../Helper/ToastMessage"

export default function PreventivePumpingOperationData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [Heading, setHeading] = useState('')
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [ShowImagePopup, setshowImagePopup] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [PDF, setPDF] = useState('')

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })

    const [PumpingStation, setPumpingStation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleShowImage = (Imageurl, heading) => {
        setshowImagePopup(true)
        setImagePopUpData(Imageurl)
        setHeading(heading)
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setPumpingStation({
            ...PumpingStation,
            ID: 0,
            Label: 'Select...'
        })
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
    }

    // console.log(WardName.DDL)
    useEffect(() => {
        const data = {
            M_SW_PumpingStationID: PumpingStation.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            Flag: 'Grid',
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handlePumpingOperationExport:handlePumpingOperationExport
        }
        if (WardName.ID != 0) {
            dispatch(PumpingOperationTableDataAPI({ data }))
        }

    }, [IsPost, To, isSearch, IsClear])

    const handlePumpingOperationExport = () => {
        const data = {
            M_SW_PumpingStationID: PumpingStation.ID,
            FromDate: FromDate,
            ToDate: ToDate,
            M_WardID: WardName.ID,
            Flag: 'Report',
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
            setPDF: setPDF
        }
        if (WardName.ID != 0) {
            dispatch(PumpingOperationExportTableDataAPI({ data }))
        }

    }
    // , [IsPost, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.PumpingOperationTableData)
    const { ExportTableData, isExportLoading } = useSelector(state => state.PumpingOperationExportTableData)

    const handleGetPDF = () => {
        if (PDF && PDF != '') {
            window.open(PDF)
        } else {
            toastErrorr("PDF not found")
        }
    }


    const handleDeleteApi = (item) => {
        const data = {
            T_SW_PumpingOperationID: item.t_sW_PumpingOperationID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(PumpingOperationDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.PumpingOperationDelete)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [PumpingStation.ID, WardName.ID])
    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"
                    DashboardName={DashboardName}
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen' />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className="col-9">
                                    <h5 className="ps-1 py-1 ">Preventive Work Pumping Operation</h5>
                                </div>
                                <div className="col-3">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <>
                                                <PreventivePumpingOperationExport
                                                    ExcelData={ExportTableData}
                                                    name={ExportTableData && ExportTableData.table[0]?.projectName}
                                                    FromDate={FromDate}
                                                    ToDate={ToDate}
                                                // searchName={searchName}
                                                />
                                                <button type="button"
                                                    className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                                    //  className="btn btn-outline-danger float-end mr-1 mb-2 px-1"
                                                    onClick={handleGetPDF}
                                                ><i className='fas fa-file-pdf mx-1'></i>PDF</button>
                                            </>
                                    }
                                </div>
                                <div className="row m-0 pt-md-1 pt-lg-1">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="row rounded2">
                                            {/* <div className="col-md-6 col-12 col-lg-2">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Financial Year :</b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: FinancialYear.ID, label: FinancialYear.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setFinancialYear({ ...FinancialYear, ID: e.value, Label: e.label })
                                                            :
                                                            setFinancialYear({ ...FinancialYear, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={FinancialYear.DDL}
                                                />

                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 ">
                                            <div className="form-group">
                                                <label className="d-block" htmlFor="NameofDepartment"><b>Month :</b></label>

                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: Month.ID, label: Month.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setMonth({ ...Month, ID: e.value, Label: e.label })
                                                            :
                                                            setMonth({ ...Month, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={Month.DDL}
                                                />

                                            </div>
                                        </div> */}
                                            <div className="col-12 col-md-3 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                        value={FromDate}
                                                        onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="ToDate"
                                                        value={ToDate}
                                                        onChange={(e) => setToDate(e.target.value)}
                                                        min={FromDate}
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-3 col-lg-2">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                />
                                            </div>
                                            <div className="col-12 col-md-3 col-lg-3" >
                                                <SeveragePumpingStationDataDDL
                                                    PumpingStation={PumpingStation}
                                                    setPumpingStation={setPumpingStation}
                                                    WardName={WardName.ID}
                                                />

                                            </div>

                                            <div className="col-12 col-md-3 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>
                                        </div>



                                        <div className="row mob_table table-responsive">
                                            <TableNote />
                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Date</th>
                                                        <th>Pumping Station</th>
                                                        <th>Pump Set</th>
                                                        <th>Start Time</th>
                                                        <th>Start Photo</th>
                                                        <th>Stop Time</th>
                                                        <th>Stop Photo</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => {
                                                            return (
                                                                <tr>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.readingDate ? item.readingDate : '-'}</td>
                                                                    <td>{item.pumpingStation ? item.pumpingStation : '-'}</td>
                                                                    <td>{item.pumpSetDetails ? item.pumpSetDetails : '-'}</td>
                                                                    <td style={{ textAlign: "right" }}>{item.startTime ? item.startTime : '00:00:00'}</td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (item.startPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye" title='View'
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => handleShowImage(item.startPhoto, 'Start Photo')}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td style={{ textAlign: "right" }}>{item.stopTime ? item.stopTime : '00:00:00'}</td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (item.stopPhoto == null) ?
                                                                                <span>-</span>
                                                                                :
                                                                                <>
                                                                                    <i className="fa-solid fa-eye" title='View'
                                                                                        style={{ cursor: 'pointer', alignItems: "center" }}
                                                                                        onClick={() => handleShowImage(item.stopPhoto, 'Stop Photo')}
                                                                                    ></i>
                                                                                </>
                                                                        }
                                                                    </td>
                                                                    <td style={{ textAlign: "center" }}>
                                                                        {
                                                                            (moment(item.readingDate).format('YYYY-MM-DD')) == (moment().format('YYYY-MM-DD')) ?
                                                                                <DeletePopup
                                                                                    open={DeletePopupShow}
                                                                                    handleDeleteApi={handleDeleteApi}
                                                                                    item={item}
                                                                                />
                                                                                :
                                                                                '-'
                                                                        }

                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                            :
                                                            <td colSpan={15}>No data found</td>
                                                    }


                                                </tbody>
                                            </table>
                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    ShowImagePopup &&
                    <ViewURL
                        Heading={Heading}
                        ImagePopUpData={ImagePopUpData}
                        setshowImagePopup={setshowImagePopup}
                    />
                }
            </div>
        </>
    )
}